export default "__VITE_ASSET__dqWLwqyo__"